import { useViewer } from '@vimeo/viewer';

/**
 *
 * @returns {boolean} Whether the current user is a staff member.
 */
export const useIsStaff = () => {
  const viewer = useViewer();
  return viewer?.user?.badge?.type === 'staff';
};
